import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  setUserLogged,
  setLoading,
  setCorporationData,
  setComponentActive,
  setManagerConfiguration,
} from "../reducers/userConfigSlice";

import { apiRest } from "../api/constants";
import { getCorporationInfo } from "../api/requests";
import { readLoginLS } from "@delibrandev/utils";
import { checkPassword, getOrderManager, logIn, setOrderManager } from "../api/login";

const Initializer = ({ onInit }) => {
  const dispatch = useDispatch();

  const { componentActive } = useSelector(
    (state) => state.aplicationConfig.userConfig
  );

  const init = async () => {
    try {
      const [corporationRes] = await Promise.all([getCorporationInfo()]);

      if (corporationRes && !corporationRes.error) {
        setFavicon(corporationRes.data.corporation.corporationId);
        dispatch(setCorporationData(corporationRes.data));
      }
    } catch (err) {
      console.error("[init] Error general al inicializar datos:", err);
    }
  };

  const autoLogin = async () => {
    const savedLogin = readLoginLS(apiRest);
    if (savedLogin?.password && savedLogin?.point && savedLogin?.login) {
      const password = savedLogin.password;
      const responsePassword = await checkPassword({ password });
      if (responsePassword && !responsePassword.error) {
        // Saved access contains only the selected ID; always read mutable settings afresh.
        let managers;
        try { managers = await getOrderManager(); } catch { managers = null; }
        const current = managers?.error === false && Array.isArray(managers.data)
          ? managers.data.find(item => item.orderManagerConfigurationId === savedLogin.point.orderManagerConfigurationId)
          : null;
        if (!current) { dispatch(setUserLogged(false)); return false; }
        const point = { orderManagerConfigurationId: current.orderManagerConfigurationId };
        const pointResponse = await setOrderManager(point);
        if (pointResponse && !pointResponse.error) {
          dispatch(setManagerConfiguration(current));
          const loginData = savedLogin?.login;
          const response = await logIn(loginData);
          if (response && !response.error) {
            dispatch(setUserLogged(true));
            dispatch(setComponentActive("kd"));
            return true;
          } else {
            dispatch(setUserLogged(false));
            return false;
          }
        } else {
          dispatch(setUserLogged(false));
          return false;
        }
      } else {
        dispatch(setUserLogged(false));
        return false;
      }
    } else {
      dispatch(setUserLogged(false));
      return false;
    }
  };

  function setFavicon(corporationId) {
    const url = `https://cdn.delibran.app/corporations/${corporationId}/configuration/favicon.png`;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = `${url}?v=${Date.now()}`;
  }

  useEffect(() => {
    const initializeApp = async () => {
      dispatch(setLoading(true));

      await autoLogin();
      await init();

      dispatch(setLoading(false));
      onInit();
    };

    initializeApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.getElementById("adminBody")?.scrollTo(0, 0);
  }, [componentActive]);

  return null;
};

export default Initializer;
